class PhotoSliderComponent extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.photo-slider__track');
    this.prevBtn = this.querySelector('.photo-slider__btn--prev');
    this.nextBtn = this.querySelector('.photo-slider__btn--next');

    if (!this.track) return;

    this.prevBtn?.addEventListener('click', () => this.slide(-1));
    this.nextBtn?.addEventListener('click', () => this.slide(1));
    this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });

    this.isDragging = false;
    this.startX = 0;
    this.startScrollLeft = 0;
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.track.addEventListener('pointerdown', this.onPointerDown);
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);

    this.updateButtons();
  }

  disconnectedCallback() {
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
  }

  slide(dir) {
    const item = this.track.querySelector('.photo-slider__item');
    if (!item) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: dir * (item.offsetWidth + gap), behavior: 'smooth' });
  }

  updateButtons() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 0;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
  }

  onPointerDown(event) {
    if (event.pointerType === 'touch') return;
    this.isDragging = true;
    this.startX = event.clientX;
    this.startScrollLeft = this.track.scrollLeft;
    this.track.style.scrollSnapType = 'none';
  }

  onPointerMove(event) {
    if (!this.isDragging) return;
    event.preventDefault();
    this.track.scrollLeft = this.startScrollLeft - (event.clientX - this.startX);
  }

  onPointerUp() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.track.style.scrollSnapType = '';
  }
}

customElements.define('photo-slider-component', PhotoSliderComponent);
